var currIndex = 0;

function updateNav() {
  let activeHeadings = document.querySelectorAll('h2.faq__title');
  for (let i = 0; i < activeHeadings.length; i++) {
    if (
      i == activeHeadings.length - 1 &&
      activeHeadings[i].getBoundingClientRect().top < 100
    ) {
      currIndex = i;
    } else if (
      activeHeadings[i].getBoundingClientRect().top < 100 &&
      activeHeadings[i + 1].getBoundingClientRect().top > 100
    ) {
      currIndex = i;
    }
  }
  let navItems = document.getElementsByClassName('faq-nav__nav__item');
  for (let i = 0; i < navItems.length; i++) {
    navItems[i].classList.remove('faq-nav__nav__item--active');
    if (currIndex == i) {
      navItems[i].classList.add('faq-nav__nav__item--active');
    }
  }
}

document.addEventListener('scroll', updateNav);
updateNav();
